import React from "react";
import { CommonModal } from "../../AbstractElements";
import { Row, Col } from "reactstrap";
import { showAlert } from "../../Services/Shared.service";
import { useNavigate } from "react-router";
import { signOutUser } from "../../Services/Auth.service";

const LogoutConformation = ({ Large, title, LargeModaltoggle }) => {

  const history = useNavigate();

  const logoutUser = () => {
    signOutUser()
      .then((result) => {
        localStorage.clear();
        showAlert("success", "Success");
        history("/login");
      })
      .catch((err) => {
        showAlert("error", "Something went wrong");
      });
  };


  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={LargeModaltoggle}
      size="md"
    >
      <Row className="driver-push-notification">
        <Col xl="12" className="push-botification-body">
          <div className="text-center">Are you sure you want to Logout ?</div>
        </Col>
        <Col xl="12" className="push-notification-footer">
          <button
            className="btn btn-primary"
            type="submit"
            onClick={() => logoutUser()}
          >
            Confirm
          </button>
        </Col>
      </Row>
    </CommonModal>
  );
};

export default LogoutConformation;
